import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Downloads from "../components/Downloads";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

const Doctors = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/downloads-bg.jpg")}
        title="Downloads"
        content=""
      />
      <Downloads />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default Doctors;
